import ExecutiveBriefingModule from './ExecutiveBriefingModule';

export default function ExecutiveBriefingFashion({ user }) {
  return (
    <ExecutiveBriefingModule 
      user={user} 
      moduleName="Fashion Design"
      moduleTitle="Fashion Design"
    />
  );
}
